import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_MSG } from '../../../constants';
import { setModalData } from '../../../store/globalSlice';
import { CloseButton, Heading, ModalWrapper, Source } from './styles'

const Modal = (props) => {
    const {reloadPage} = props;
	const { modalData } = useSelector((state) => state.global);
    const dispatch = useDispatch();
    const [reloadingWIP, setReloadingWIP] = useState(false)
    const onClose = () => {
        if(reloadPage){
            setReloadingWIP(true);
            window?.location?.reload();
        }
        dispatch(setModalData(null));
    }
    const getErrorText = () =>{
        const errorText = modalData?.sourceData;
        return errorText;
    }
    return (
        <div
            className={'modal fade show d-block '}
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: '9999',
            }}
            tabIndex={-1}
            data-bs-backdrop='static'
            aria-hidden='true'
        >
            <ModalWrapper>
                <Heading>{DEFAULT_MSG}</Heading>
                <Source>{getErrorText()}</Source>
                <CloseButton disabled={reloadingWIP} onClick={onClose}>{reloadPage ? `Refresh Page` : `Close`}</CloseButton>
            </ModalWrapper>
        </div>
    )
}

export default Modal